import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { timesheetreportService } from '../../services/timesheetreportsService';
import { timesheetService } from '../../services/timesheetService';
import { formatterhelper } from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import { loader } from '../../compnents/loadermd';
import { dataExporthelper } from '../../helpers/exporthelper';

// Same report as reports.js (AdminReports), but the Employee filter defaults
// to 'ALL' instead of requiring one to be picked first - showreport_gettimesheet
// already supports 'ALL' server-side, scoped to the current manager's
// project the same way the "ALL" client/subclient options are. Picking a
// specific employee still narrows the report down like on the Reports page.
const AllUsersReports = ({ tabname }) => {

    const [formData, setFormData] = useState({
        fromdate: '',
        todate: '',
        employee: 'ALL',
        client: 'ALL',
        subclient: 'ALL',
    });
    const [datacomp, setDatacomp] = useState([]);
    const [dataavail, setDatastate] = useState(false);
    const [cleintscomp, setClientscomp] = useState([]);
    const [subclientscomp, setsubClientscomp] = useState([]);
    const [empcomp, setempcomp] = useState([]);
    const [totalpages, setPages] = useState(0);
    const [filterobj, setfilterobj] = useState({});
    const [isloaded, setloading] = useState(true);
    const [isdataexported, setDataexport] = useState(true);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        getemplist();
        _getclientslist();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name == 'client') {
            _getsubclient({ clientid: value });
        }
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.fromdate == '') {
            newErrors.fromdate = 'Field is required';
            valid = false;
        }

        if (formData.todate == '') {
            newErrors.todate = 'Field is required';
            valid = false;
        }

        if (formData.employee == '') {
            newErrors.employee = 'Field is required';
            valid = false;
        }

        if (formData.client == '') {
            newErrors.client = 'Field is required';
            valid = false;
        }

        if (formData.subclient == '') {
            newErrors.subclient = 'Field is required';
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }
        let reportobj = {
            'clientid': formData.client,
            'employeeid': formData.employee,
            'frmdt': formatterhelper.dateformatter({ date: formData.fromdate }),
            'todt': formatterhelper.dateformatter({ date: formData.todate }),
            'subclientid': formData.subclient
        };
        setfilterobj(reportobj);
        getreports({ reportobj: reportobj });
    };

    function getreports({ reportobj, pageno }) {
        let emparr = [];
        setloading(false);
        timesheetreportService.showreportgettimesheet({ formdataobj: reportobj, pageno: pageno })
            .then((response) => {
                if (response.status == 200) {
                    response.data.data.data.forEach((value, index) => {
                        let role = value.user_role == null ? value.user_roletype : value.user_role;
                        emparr.push((<tr>
                            <th>{value.ID}</th>
                            <td>{value.Date}</td>
                            <td>{value.User}</td>
                            <td>{value.client}</td>
                            <td>{value.subclient}</td>
                            <td></td>
                            <td>{value.Task}</td>
                            <td>{role}</td>
                            <td>{value.user_roletype}</td>
                            <td>{value.BilledMinutes}</td>
                            <td>{value.Minutes}</td>
                            <td>{value.Count}</td>
                            <td>{value.Remarks}</td>
                            <td>{value.approved_date}</td>
                            <td>{value.timesheetfilleddt}</td>
                            <td>{value.costcentername}</td>
                            <td>{value.clcostcenter}</td>
                            <td>{value.qapercentval}</td>
                            <td>{value.qapercentage}</td>
                        </tr>));
                    });

                    let totalpage = response.data.data.total;
                    setPages(totalpage);
                    setDatacomp(emparr);
                    setDatastate(true);
                    setloading(true);
                } else {
                    setDatacomp([]);
                    setDatastate(false);
                    setloading(true);
                    setPages(0);
                }
            }).catch((error) => {
                console.log(error);
                setDatacomp([]);
                setDatastate(false);
                setloading(true);
                setPages(0);
            });
    }

    function getemplist() {
        let managerid = 1;
        let emparr = [{ label: 'ALL', value: 'ALL' }];
        timesheetreportService.getemployeelist({ managerid: managerid, accesstype: 'all' }).then((response) => {
            response.data.data.forEach((value, index) => {
                emparr.push({ label: value.name, value: value.id });
            });
            setempcomp(emparr);
        }).catch((error) => {

        });
    }

    function _getclientslist() {
        let managerid = 1;
        let emparr = [];
        timesheetreportService.getclientslist({ managerid: managerid }).then((response) => {
            response.data.data.forEach((value, index) => {
                if (value.client != '') {
                    emparr.push((<option value={value.client}>{value.client}</option>));
                }
            });
            setClientscomp(emparr);
        }).catch((error) => {

        });
    }

    function _getsubclient({ clientid }) {
        try {
            let _clientid = clientid;
            let emparr = [];
            timesheetService.getallsubclient_post({ client: _clientid }).then((response) => {
                if (response != undefined) {
                    response.data.data.forEach((value, index) => {
                        if (value.subclient != '') {
                            emparr.push((<option value={value.subclient}>{value.subclient}</option>));
                        }
                    });
                    setsubClientscomp(emparr);
                }
            }).catch((error) => {

            });
        } catch (e) {
            console.log(e);
        }
    }

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        let pageno = 1;
        if (event.first == 0) {
            pageno = 1;
        } else {
            pageno = ((event.first / rows) + 1);
        }
        getreports({ reportobj: filterobj, pageno: pageno });
    };

    const exportexcel = () => {
        if (!validateForm()) {
            return;
        }
        let filterobj = {
            'clientid': formData.client,
            'employeeid': formData.employee,
            'frmdt': formatterhelper.dateformatter({ date: formData.fromdate }),
            'todt': formatterhelper.dateformatter({ date: formData.todate }),
            'subclientid': formData.subclient
        };

        setDataexport(false);

        timesheetreportService.showrptexporttoexcel({ formdataobj: filterobj }).then((response) => {
            exportToExcel(response.data.data);
            setDataexport(true);
        });
    }

    function exportToExcel(data) {
        dataExporthelper.exportToExcel(data, { filename: 'AllUsersReportsexcel' });
    }

    return (
        <>
            <div className="invisible-divider-sm"></div>
            <h6>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
                <form onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className="col-md-2">
                            <label className='pull-left'>From date</label>
                            <Calendar value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' required />
                            {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                        </div>
                        <div className="col-md-2">
                            <label className='pull-left'>To date</label>
                            <Calendar value={formData.todate} name="todate" onChange={handleChange} className='calender-custom-style' required />
                            {errors.todate && <span className='error'>{errors.todate}</span>}
                        </div>
                        <div className="col-md-2">
                            <label className='pull-left'>Employee</label>
                            <Dropdown name="employee" value={formData.employee} options={empcomp} onChange={handleChange}
                                filter filterPlaceholder="Search employee" className='dropdown-custom-style' />
                            {errors.employee && <span className='error'>{errors.employee}</span>}
                        </div>
                        <div className="col-md-2">
                            <label className='pull-left'>Client</label>
                            <select className='form-control' name='client' value={formData.client} onChange={handleChange}>
                                <option value='ALL'>ALL</option>
                                {cleintscomp}
                            </select>
                            {errors.client && <span className='error'>{errors.client}</span>}
                        </div>
                        <div className="col-md-2">
                            <label className='pull-left'>Subclient</label>
                            <select className='form-control' name='subclient' value={formData.subclient} onChange={handleChange}>
                                <option value='ALL'>ALL</option>
                                {subclientscomp}
                            </select>
                            {errors.subclient && <span className='error'>{errors.subclient}</span>}
                        </div>
                        <div className="col-md-2">
                            <div className='button-wrapper-style'>
                                <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                                &nbsp;&nbsp;&nbsp;
                                <Button type='button' stype="button" label="Export" severity="info" rounded className='custom-btn-style' onClick={() => exportexcel()}> {!isdataexported ? (loader.Loadermd()) : (<></>)}</Button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
                <div className='row'>
                    <div className='col-md-6'></div>
                    <div className='pagination col-md-6'>
                        {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        {!isloaded ? loader.Loadermd() : dataavail ?
                            (/* The app layout puts pages inside a flex item (.content-box,
                                 flex:0.8) whose automatic min-width is its content's
                                 min-content, so a wide table here would otherwise stretch
                                 that whole column and scroll the page body sideways instead
                                 of just this table. width:0 + minWidth:'100%' keeps this
                                 scroller from contributing to that sizing while still
                                 filling the available width. */
                            <div style={{ overflowX: 'auto', width: 0, minWidth: '100%' }}>
                            <table class="table table-bordered" style={{ minWidth: '1400px' }}>
                                <thead>
                                    <tr>
                                        <th scope="col">Id</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">Client</th>
                                        <th scope="col">Sub Client</th>
                                        <th scope="col">Budget hours</th>
                                        <th scope="col">Task</th>
                                        <th scope="col">Roles</th>
                                        <th scope="col">Role type</th>
                                        <th scope="col">Billed hours in(Min)</th>
                                        <th scope="col">Actual hours in(Min)</th>
                                        <th scope="col">Count</th>
                                        <th scope="col">Remarks</th>
                                        <th scope="col">Approved date</th>
                                        <th scope="col">Filled date</th>
                                        <th scope="col">Cost Center</th>
                                        <th scope="col">CL Cost Center</th>
                                        <th scope="col">QA Minutes</th>
                                        <th scope="col">QA %</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {datacomp}
                                </tbody>
                            </table>
                            </div>) : (<p>No data Found</p>)}
                    </div>
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
        </>
    );
}

export default AllUsersReports;
